import { render, staticRenderFns } from "./ArchivedInfocardsListView.vue?vue&type=template&id=c84193a8&"
import script from "./ArchivedInfocardsListView.vue?vue&type=script&lang=js&"
export * from "./ArchivedInfocardsListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports